export default __webpack_public_path__ + "static/media/1_bookline.20796bdc.svg";